import axios from 'axios'
import { Message } from 'element-ui'
import {
  getToken, removeToken
  //  setToken
} from '@/utils/auth'
// import { login } from './index'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 300000 // request timeout,
  /*  headers: {
                'Content-Type': 'application/json'
              } */
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
  }
  // if (store.getters.token) {
  //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  //   // config.headers['X-Token'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  // }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})
// respone interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (status.status == '401') {
      Message({
        message: '登录过期，请重新登录！',
        type: 'error',
        duration: 5 * 1000
      })
      removeToken()
    } else if ((res.status && res.status !== 0) || (res.code && res.code !== 10000)) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },

  /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
  //  const res = response.data;
  //     if (res.code !== 20000) {
  //       Message({
  //         message: res.message,
  //         type: 'error',
  //         duration: 5 * 1000
  //       });
  //       // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //         MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //           confirmButtonText: '重新登录',
  //           cancelButtonText: '取消',
  //           type: 'warning'
  //         }).then(() => {
  //           store.dispatch('FedLogOut').then(() => {
  //             location.reload();// 为了重新实例化vue-router对象 避免bug
  //           });
  //         })
  //       }
  //       return Promise.reject('error');
  //     } else {
  //       return response.data;
  //     }
  error => {
    console.log('err', error) // for debug
    console.log(error.response)
    let message = (error.response && error.response.data.msg) || '网络异常'
    switch (error.response.status) {
      case 401:
        message = '登录过期，请重新登录'
        // login().then(res => {
        //   setToken(res.data.token)
        // })
        removeToken()
        break
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/api/request.js